module.exports = __webpack_public_path__ + "images/ab29a63587f968347085cf7f9cd93f3e-stayingLogoNew.png";